
var $blocoFotos;

$(document).ready(function(){
    $blocoFotos = $('.colfotos--bloco-foto');

    // hover das imagens
    $blocoFotos.hover(function(){
        $(this).find(".box-infos").addClass("bloco-foto-show");
        }, function(){
        $(this).find(".box-infos").removeClass("bloco-foto-show");
    });

    // mostra elementos no scroll
    mostraBlocos();
    $(window).scroll(function(){ mostraBlocos() })
}); 


function mostraBlocos(){
    $blocoFotos.each(function() {
        if($(this).css('opacity')==0 && isInView($(this))) $(this).addClass("bloco-show");
    });
}
